import React from "react";
import {
  Col,
  Collapse,
  Divider,
  Image,
  Layout,
  Row,
  Skeleton,
  Space,
} from "antd";
import { Content, Footer, Header } from "antd/es/layout/layout";
import Title from "antd/es/typography/Title";
import { Link } from "react-router-dom";
import { usePrivacyPolicy } from "../hooks/usePolicy";

const PrivacyPolicy = () => {
  const { data: data, isLoading: isLoading } = usePrivacyPolicy();

  return (
    <Layout
      style={{
        minHeight: "100vh",
      }}
    >
      <Content>
        <Row align="middle" style={{ paddingRight: 20, paddingLeft: 20 }}>
          <Col flex={1}>
            <Divider />
          </Col>
          <div style={{ width: 20 }} />
          <Col>
            <Title
              style={{
                paddingTop: 18,
                fontFamily: "MyFont",
              }}
              level={4}
            >
              سياسة الخصوصية
            </Title>
          </Col>
          <div style={{ width: 20 }} />
          <Col flex={1}>
            <Divider />
          </Col>{" "}
        </Row>
        <Space
          direction="vertical"
          size="small"
          style={{ padding: 20, width: "100%" }}
        >
          <Skeleton loading={isLoading} />
          {data &&
            data.map((item) => (
              <Collapse
                expandIconPosition="end"
                style={{
                  borderColor: "#f3f4f7",
                  borderRadius: 8,
                  boxShadow: "1px 2px 3px 1px rgba(208, 216, 243, 0.6)",
                }}
                size="middle"
                bordered={true}
                items={[item]}
              />
            ))}
        </Space>
      </Content>

      <Footer
        style={{
          textAlign: "center",

          borderTop: "1px solid #e8e8e8",
        }}
      >
        Agricare ©2024 All rights reserved
      </Footer>
    </Layout>
  );
};

export default PrivacyPolicy;
